import React from 'react';
import { Link, NavLink, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { DropdownButton, MenuItem } from 'react-bootstrap';
//components
import Logo from '../../components/logo/Logo';
import SignupButton from '../../components/signupbutton/SignupButton'
//styles
import 'bootstrap/dist/css/bootstrap.css';
import '../../../ext/font-awesome-4.7.0/css/font-awesome.css';
import './navbar.styl';
//import text in correct language
import { NavbarText as NavbarTextEN } from '../../input-text/en/navbar';
import { NavbarText as NavbarTextNL } from '../../input-text/nl/navbar';

class NavBar extends React.Component {

  constructor(props){
    super(props);
    this.setLocale = this.setLocale.bind(this);

    if(window.innerWidth < 991){
      this.state = {
        mode: 'solid',
        folded: 'folded',
        login: false,
        btnText: '',
        name: ''
      }
    }
    else if(this.props.location.pathname === '/'){
      this.state = {
        mode: 'transparent',
        folded: 'unfolded',
        login: false,
        btnText: '',
        name: ''
      };
    }
    else {
      this.state = {
        mode: 'solid',
        folded: 'unfolded',
        login: false,
        btnText: '',
        name: ''
      };
    }
  }

  componentWillMount = () => {
    const name = localStorage.getItem('name');
    if(name)
      this.setState({login: true, name});
    else
      this.setState({login: false, name});
  }

  componentWillReceiveProps = (nextProps) => {
    if (nextProps.location.pathname !== '/') {
      this.setState({mode: 'solid'});
    }
    else if(window.innerWidth >= 991 && window.pageYOffset <= window.innerHeight * 0.8)
      this.setState({mode: 'transparent'});

    const name = localStorage.getItem('name');
    if(name)
      this.setState({login: true, name: name});
    else
      this.setState({login: false});
  }

  componentDidMount = () => {
    if(this.props.location.pathname !== '/'){
      this.setState({mode: 'solid'});
    }
    //add scroll listener to the window
    window.addEventListener('scroll', this.changeMode);
    window.addEventListener('resize', this.foldOnResize);
    //add event listener to every button in navbar so that it folds up on click
    const navs = document.getElementsByClassName('key');
    for(let i = 0; i <  navs.length; i++){
      navs[i].addEventListener('click', this.foldOnClick);
    }
  }

  setButton = () => {
    if(this.state.login){

      const text = (<span><i className="fa fa-user-o" aria-hidden="true"></i><span className='dash-username'>{' '+this.state.name}</span></span>);
      return {
        text,
        path: '/dashboard'
      }
    }
    else
      return {
        text: this.NavbarText.key7,
        path: '/login'
      }
  }

  changeMode = () => {
    if(window.innerWidth >= 991){
      //once it's past 80% of the page
      if(window.pageYOffset > window.innerHeight * 0.8){
        this.setState({mode: 'solid', folded: 'folded'});
      }
      else if(this.props.location.pathname === '/'){
        this.setState({mode: 'transparent', folded: 'unfolded'});
      }
      else {
          this.setState({folded: 'unfolded'});
      }
    }
    else{
      this.setState({folded: 'folded'});
    }
  }

  toggleFold = () => {
    if(this.state.folded === 'folded'){
      this.setState({folded: 'unfolded'});
    }
    else{
      this.setState({folded: 'folded'})
    }
  }

  foldOnResize = () => {
    if(window.innerWidth < 991){
      this.setState({folded: 'folded', mode: 'solid'});
    }
    else if(window.innerWidth >= 991){
      if(window.pageYOffset <= window.innerHeight * 0.8){
        if(this.props.location.pathname === '/')
          this.setState({folded: 'unfolded', mode: 'transparent'});
        else {
          this.setState({folded: 'unfolded'});
        }
      }
    }
  }

  foldOnClick = () => {
    if(window.innerWidth < 991 && this.state.folded === 'unfolded'){
      this.setState({folded: 'folded'});
    }
  }

  setLocale(locale) {
      this.NavbarText = null;
      switch (this.props.locale) {
          case 'en':
              this.NavbarText = NavbarTextEN;
              break;
          case 'nl':
              this.NavbarText = NavbarTextNL;
              break;
          default:
              this.NavbarText = NavbarTextEN;
      }
  }

  render(){
    this.setLocale(this.props.locale);

    return(
      <div id="navbar" className={'flexbar '+this.state.mode+' '+this.state.folded}>
        <div className='flexbar-brand'>
          <div className='flexbar-logo key'>
            <Link to='/'><Logo ver={this.state.folded} neg='neg'/></Link>
          </div>
        </div>
        <div className='key toggle fold-key' onClick={this.toggleFold}>
          <i className="fa fa-navicon fa-2x"></i>
        </div>
        <div className='key login'>
          <Link to={this.setButton().path} className='button button--primary'>{this.setButton().text}</Link>
        </div>
        <div className='flexbar-navigation'>
          { this.props.hasTranslation &&
            <DropdownButton
              className="navbar__locale"
              bsStyle="default"
              title={ this.props.locale.toUpperCase() }
              id="locale-dropdown"
            >
              <MenuItem disabled={ this.props.locale === 'en' } onSelect={ () => this.props.setLocale('en', true) }>English</MenuItem>
              <MenuItem disabled={ this.props.locale === 'nl' } onSelect={ () => this.props.setLocale('nl', true) }>Nederlands</MenuItem>
            </DropdownButton>
          }
          <div className='flexbar-nav key products'>
            <NavLink to='/products'>{this.NavbarText.key1}</NavLink>
          </div>
          <div className='flexbar-nav key industries'>
            <NavLink to='/industries'>{this.NavbarText.key2}</NavLink>
          </div>
          <div className='flexbar-nav key pricing'>
            <NavLink to='/pricing'>{this.NavbarText.key3}</NavLink>
          </div>
          <div className='flexbar-nav key blog'>
            <a href="https://medium.com/aircheckr" target="_blank">{this.NavbarText.key4}</a>
          </div>
          <div className='flexbar-nav key developers'>
            <NavLink to='/developers'>{this.NavbarText.key5}</NavLink>
          </div>
          <div className='flexbar-nav key help'>
            <NavLink to='/help-and-guides'>{this.NavbarText.key6}</NavLink>
          </div>
          <SignupButton />
        </div>
      </div>
    );
  }
};

const mapStateToProps = (state) => {
  return {
    locale: state.locale.value,
    hasTranslation: state.locale.hasTranslation,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setLocale: (locale, hasTranslation) => dispatch({
      type: 'UPDATE_LOCALE',
      locale,
      hasTranslation,
    }),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(NavBar));



// WEBPACK FOOTER //
// ./src/containers/navbar/NavBar.js